module.exports = __webpack_public_path__ + "img/factory.b53d094a.png";